// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Leaf: React.FC = () => {
    return (
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 54 45" enableBackground="new 0 0 54 45" xmlSpace="preserve">
<path id="Fill-1" fillRule="evenodd" clipRule="evenodd" fill="#444244" d="M38,44.1c5.3-0.7,16-2.1,16-2.1V28.6c0,0-1-0.3-1.2-0.4c-0.1,0-1.1-0.1-1.5-0.9
	c-0.2-0.4-0.2-0.7-0.2-0.7l0.7-3.6l-9.6,2.7c-3.6,0.4-1.8-1.9-1.8-1.9l9.4-11.4c0,0-4.8-0.4-4.7-0.4c-2.6-0.2-2.2-1.6-2.2-1.6
	l-0.7-9.9l-8.5,5.1c0,0-1,1.1-2.6-1c0.1,0.1-3-3.6-3-3.6l-4,14.2c0,0-0.9,2.9-2.6-0.4l-3.3-9.5l-2.6,2.6c0,0-1,0.9-2.3-0.4
	c0,0-6.9-5.2-6.9-5.2L5,11.4c0,0-0.2,1.4-1.5,0.9c-0.1,0-3.5-0.4-3.5-0.4l8.8,17c0,0,0.7,1.4-0.3,2c0,0-2.8,2.6-2.8,2.6l-0.1,0.2
	l10.3,4.2c0,0,2.5,0.7,1.8,1.9c0,0,0,0,0,0c0,0-3.8,5.3-3.8,5.3h9.4c0,0,0.7-2,0.7-2c0,0,0,0,0,0c0.6-1.2,2.6,0.4,2.6,0.4
	c0.8,0.5,2.3,1.6,2.3,1.6h7.6C36.5,45,38,44.1,38,44.1L38,44.1z"/>
</svg>
    );
};


export default React.memo(Leaf);
